<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <div
      class="grid gap-x-3 overflow-hidden"
      style="grid-template-columns: 25% 1fr"
    >
      <div class="overflow-hidden pr-3">
        <div class="flex flex-col gap-y-2 overflow-y-auto">
          <ul class="flex gap-x-3 items-center">
            <strong>{{ state.model?.number }}</strong>
            <text class="text-gray-400 text-xs">采购付款</text>
            <c_status
              arrName="Office_Expense_Apply_Status"
              :value="state.model?.status"
              :key="state.model?.status"
              showBg
            />
          </ul>
          <c_cell title="付款金额">
            <c_money
              :key="state.model.amount"
              :value="state.model.amount"
              :size="20"
              :prefix="false"
              bold
            />
          </c_cell>
          <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
          <c_cell title="收款信息">
            <template #default>
              <div
                class="flex gap-x-2"
                v-if="state.model?.is_supplier_purchase"
              >
                <text>{{
                  state.model?.supplierBankAccount?.opening_bank
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.supplierBankAccount?.name
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.supplierBankAccount?.account
                }}</text>
              </div>
              <div class="flex gap-x-2" v-else>
                <text>{{ state.model?.opening_bank }}</text>
                <text class="text-gray-400">{{
                  state.model?.bank_account_name
                }}</text>
                <text class="text-gray-400">{{
                  state.model?.bank_account
                }}</text>
              </div>
            </template>
          </c_cell>

          <c_cell title="申请说明" :value="state.model?.intro" />
          <c_cell title="附件">
            <template #default>
              <div
                class="flex flex-wrap gap-x-5 gap-y-2"
                v-if="state.model?.attachment?.length > 0"
              >
                <text
                  v-for="file in state.model?.attachment"
                  :key="item"
                  class="hover:underline cursor-pointer text-green-700"
                  @click="$openFile(file.file_url)"
                >
                  {{ file.filename }}
                </text>
              </div>
              <text v-else>-</text>
            </template>
          </c_cell>
          <ul class="text-gray-400 text-xs">
            审核进度：
          </ul>
          <el-timeline class="!text-xs" style="padding-left: 5px">
            <el-timeline-item
              :hollow="item.status == 0"
              :type="
                item.status === 0
                  ? 'info'
                  : item.status === 1
                  ? 'primary'
                  : 'danger'
              "
              hide-timestamp
              v-for="item in state.flowApproveStepList"
              :key="item"
            >
              <div class="flex gap-x-3">
                <strong>{{ item.step_name }}</strong>
                <c_status arrName="Common_Check_Status" :value="item.status" />
                <template v-if="item.status == 1">
                  <text>{{ item.approve_admin_name }}</text>
                  <text class="text-gray-400">{{
                    item.approve_department_name
                  }}</text>
                  <text class="text-gray-400">{{ item.approve_time }}</text>
                </template>
              </div>
            </el-timeline-item>
          </el-timeline>
          <template v-if="state.model.status == 2">
            <c_cell title="付款说明" :value="state.model?.transaction_remark" />
            <c_cell title="付款附件">
              <template #default>
                <div
                  class="flex flex-wrap gap-x-5 gap-y-2"
                  v-if="state.model?.transaction_attachment?.length > 0"
                >
                  <text
                    v-for="file in state.model?.transaction_attachment"
                    :key="item"
                    class="hover:underline cursor-pointer text-green-700"
                    @click="$openFile(file.file_url)"
                  >
                    {{ file.filename }}
                  </text>
                </div>
                <text v-else>-</text>
              </template>
            </c_cell>
          </template>
        </div>
      </div>
      <div class="flex flex-col mb-12 overflow-hidden">
        <strong>采购明细</strong>
        <div class="flex-1 overflow-y-auto mt-2 pr-3">
          <el-card
            v-for="(row, index) in state.list_data"
            :key="row"
            class="mb-3"
          >
            <template #header>
              <div class="flex gap-x-5">
                <strong>{{ index + 1 + "." + row.name }}</strong>
                <text class="text-gray-400" style="margin-left: -10px">{{
                  row.number
                }}</text>
                <text>{{ row.d_cost_type_pname }}</text>
                <c_cell title="结算价">
                  <c_money
                    :value="row.amount"
                    :prefix="false"
                    :size="14"
                    color="#1e90ff"
                  />
                </c_cell>
                <c_cell title="已付">
                  <c_money
                    :value="row.paid_amount"
                    :prefix="false"
                    :size="14"
                    color="#080"
                  />
                </c_cell>
                <c_cell title="应付">
                  <c_money
                    :value="row.unpaid_amount"
                    :prefix="false"
                    :size="14"
                    color="#ffa500"
                  />
                </c_cell>
                <c_cell title="本次付款" class="flex-1">
                  <c_money
                    :value="row.this_amount"
                    :prefix="false"
                    :size="18"
                    bold
                  />
                </c_cell>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </div>
            </template>
            <table class="w-full" cellpadding="10">
              <thead>
                <tr class="text-left bg-gray-100">
                  <th style="width: 12%">所属分会</th>
                  <th style="width: 6%">类型</th>
                  <th style="width: 15%">名称</th>
                  <th style="width: 15%">规格</th>
                  <th style="width: 6%" class="text-center">单位</th>
                  <th style="width: 10%" class="text-center">单价</th>
                  <th style="width: 6%" class="text-center">数量</th>
                  <th style="width: 10%" class="text-center">合计</th>
                  <th>备注</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in row.meetingPurchaseItemData?.list"
                  :key="item"
                >
                  <td>{{ item.meetingPlace?.name }}</td>
                  <td>{{ item.d_cost_type_pname }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.specification || "-" }}</td>
                  <td class="text-center">
                    {{ item.d_measure_unit_name || "-" }}
                  </td>
                  <td class="text-center">{{ item.bill_price }}</td>
                  <td class="text-center">{{ item.bill_count }}</td>
                  <td class="text-center">{{ item.bill_amount }}</td>
                  <td>{{ item.bill_remark || "-" }}</td>
                </tr>
              </tbody>
            </table>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_purchase_applyPaymentRecordDetail } from "@/http/meeting";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      list_data: [],
      check: {
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        meeting_purchase_applyPaymentRecordDetail(props.id).then((res) => {
          if (res.status == 200) {
            const { info, meetingPurchaseList, flowApproveStepList } =
              res.data?.data || {};
            state.model = info;
            state.list_data = meetingPurchaseList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });

    return { state, formDom };
  },
};
</script>
<style scoped></style>
